import { MESSAGE_TYPE } from '@constants/messages';

/**
 * @typedef Translation
 * @prop {string} id String ID
 * @prop {string} defaultMessage Default value if matching translation is not found
 */

/**
 * Returns the correct title for the message page, based on the message type
 * @param {string} [messageType] Message type
 * @returns {Translation} Page title
 **/
export const getPageTitle = messageType => {
  switch (messageType) {
    case MESSAGE_TYPE.GENERAL:
      return {
        defaultMessage: 'General Messages',
        id: 'pages.messages.general-title',
      };

    case MESSAGE_TYPE.FILING:
      return {
        defaultMessage: 'Filing Messages',
        id: 'pages.messages.filing-title',
      };

    default:
      return {
        defaultMessage: 'Messages',
        id: 'pages.messages.title',
      };
  }
};
